import type { RouteRecordRaw } from "vue-router";
import { APP_SETTINGS_ACCOUNT_ROUTES as ACCOUNT } from "@/Generated/Routes/paths";

const account: RouteRecordRaw[] = [
  {
    ...ACCOUNT.root,
    meta: {
      i18nTitle: "account.account-title",
    },
    component: () => import("@/Views/settings/account/Account.vue"),
  },
  {
    ...ACCOUNT.username.root,
    meta: {
      i18nTitle: "account.username.change_name_and_surname-title",
    },
    component: () => import("@/Views/settings/account/username/Username.vue"),
  },
  {
    ...ACCOUNT.password.root,
    meta: {
      i18nTitle: "account.password",
    },
    component: () => import("@/Views/settings/account/password/Password.vue"),
  },
  {
    ...ACCOUNT.email.root,
    meta: {
      i18nTitle: "account.email",
    },
    component: () => import("@/Views/settings/account/email/Email.vue"),
  },
  {
    ...ACCOUNT.description.root,
    meta: {
      i18nTitle: "account.change_description",
    },
    component: () => import("@/Views/settings/account/description/Description.vue"),
  },
  {
    ...ACCOUNT.iban.root,
    meta: {
      i18nTitle: "account.iban",
    },
    component: () => import("@/Views/settings/account/iban/Iban.vue"),
  },
  {
    ...ACCOUNT.delete.root,
    meta: {
      i18nTitle: "account.delete_account",
    },
    component: () => import("@/Views/settings/account/delete/Delete.vue"),
  },
  {
    ...ACCOUNT.delete.reason.root,
    meta: {
      i18nTitle: "account.delete_account",
    },
    component: () => import("@/Views/settings/account/delete/DeleteReason.vue"),
  },
];

export default account;
